/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SubmitGuessResponse = {
    playId: string;
    /**
     * Game status after this guess: 0=in_progress, 10=completed, 20=timed_out
     */
    status: SubmitGuessResponse.status;
    /**
     * The submitted guess
     */
    guess: string;
    /**
     * Feedback for this guess: 0=absent, 1=present, 2=correct
     */
    feedback: Array<0 | 1 | 2>;
    /**
     * All guesses so far
     */
    guesses: Array<string>;
    /**
     * All feedback arrays
     */
    allFeedback: Array<Array<0 | 1 | 2>>;
    attemptsRemaining: number;
    gameOver: boolean;
    won?: boolean | null;
    answerWord?: string | null;
    reward?: {
        whalePoints?: number;
        tokens?: number;
        /**
         * Balance in cents
         */
        balance?: number;
    } | null;
};
export namespace SubmitGuessResponse {
    /**
     * Game status after this guess: 0=in_progress, 10=completed, 20=timed_out
     */
    export enum status {
        '_0' = 0,
        '_10' = 10,
        '_20' = 20,
    }
}

